export const SHOW_SUMMARIZE = process.env.REACT_APP_SHOW_SUMMARIZE === 'true';

export const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes
export const MAX_CACHE_ENTRIES = 20;
export const FETCH_DEBOUNCE_DELAY = 300;

export const PAGE_SIZES = {
  UNAUTHENTICATED: [10],
  TRIAL: [10, 30],
  RESTRICTED: [10, 30],
  FULL: [10, 20, 25, 40, 50, 100],
};

export const FILTER_VALIDATION = {
  REFERENCE_MIN_LENGTH: 8,
  PMID_MIN_LENGTH: 8,
};

export const POPUP_MESSAGES = {
  UNAUTHENTICATED: {
    text: 'As an unregistered user, you are seeing only the top 10 results (sorted by score) for each query. Register to view more. Learn about our',
    linkText: 'plans here',
    linkUrl: '/plans',
  },
  RESTRICTED_BROWSE: {
    text: 'You are viewing the top 30 results, ordered by score for each query. To view more,',
    linkText: 'upgrade your account.',
    linkUrl: '/Profile-area',
    additionalText: 'Learn about our',
    additionalLinkText: 'plans here',
    additionalLinkUrl: '/plans',
  },
  TRIAL: {
    text: 'Only the top 30 results are shown.',
    linkText: 'Upgrade your account',
    linkUrl: '/Profile-area',
    additionalText: 'to see all results. Learn about our',
    additionalLinkText: 'plans here',
    additionalLinkUrl: '/plans',
  },
};

export const ERROR_MESSAGES = {
  SESSION_EXPIRED: 'Session expired',
  NO_COLUMNS: 'No columns selected',
  NO_DATA_FOR_SOURCE: (source: string, tab: string) => `No data available for "${source}" in ${tab}`,
  CONTENT_NOT_AVAILABLE: 'This content is not available with your current plan',
  INCOMPLETE_FILTER: (filterNames: string) => `You must write the full ${filterNames} to filter`,
};